import React from "react";
import { Link } from "react-router-dom";

const Banner = ({ scrollToDiv, el1 }) => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row align-items-center justify-content-end">
            <div className="col-lg-6 col-md-6 mb-5 mb-lg-0">
              <div className="heading">
                <h1 className="mb-5">
                  Destination To Get The Best{" "}
                  <span>Dedicated Developers Remotely!</span>
                </h1>
                {/* <p className="text-justify">
                  To introduce ourselves briefly, Shine Infosoft is an Ahmedabad
                  (Gujarat, INDIA) based company providing ICT solutions and
                  dedicated resources remotely. Our excellent team of 100+ IT
                  professionals having domain expertise in different
                  technologies and platforms would help you out in bridging
                  technical gap remotely. For more details about us, you may
                  visit our website{" "}
                  <a href="https://shineinfosoft.in/" target="_blank">
                    Shine Infosoft
                  </a>
                </p> */}
                <p className="text-justify"><a href="https://www.shineinfosoft.in/portfolio-pdf/CompanyPortfolio-ShineInfosoft.pdf" target="_blank"><strong>Shine Infosoft</strong></a> is a leading <strong>Mobile and Web App Development Company</strong>, Dedicated to delivering cutting-edge digital solutions that empower businesses to grow, scale, and succeed in an ever-evolving digital world.
                Since our inception over <strong>10+ years ago</strong>, we have been at the forefront of technology innovation, specializing in <strong>Custom Software Development, Mobile and Web Applications, UI/UX Design</strong>, and <strong>Digital Marketing Services</strong>. Our goal is simple — to turn ambitious ideas into high-performing digital products that solve real business challenges.</p>
                {/* <h2>What We Do Best</h2>
                <p className="text-justify">With a talented team of 100+ skilled professionals, we provide full-cycle development services that are tailored to meet the specific needs of startups, SMBs, and enterprises. From strategy and design to development, deployment, and ongoing support — we’re with you every step of the way.</p> */}
                <Link to="HireDeveloper" className="btn">
                  <span>Hire Remote Developer</span>
                </Link>
                <a className="btn contactBtn" onClick={() => scrollToDiv(el1)}>
                  <span>Contact Now</span>
                </a>
                {/* <Link className='viewMore' to="HireDevelopers">More Information <i className='fa fa-angle-right ml-3'></i></Link> */}
                {/* <p className='mt-3 applyJob' data-aos="slide-up">Looking for jobs instead? <Link to='/GetHire'>Apply for jobs</Link></p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
